import moment from 'moment'

export default {
    formatFullDateAndTime: (date) => {
        return moment(date).format('MMMM Do, YYYY, h:mm A')
    },
    dateAndTimeStringsToISO8601UTC: (dateStr, timeStr) => {
        if (timeStr && timeStr !== '') {
            const dt = moment(`${dateStr} ${timeStr}`, 'YYYY-MM-DD HH:mm')
            return dt.toISOString()
        } else {
            const dt = moment(dateStr, 'YYYY-MM-DD')
            return `${dt.format('YYYY-MM-DD')}Z`
        }
    },
    iso8601To24HrTimeString: (dateStr) => {
        if (dateStr.length === 'YYYY-MM-DDZ'.length) {
            return null
        }
        return moment(dateStr).format('HH:mm');
    },
    iso8601ToDateString: (dateStr) => {
        if (dateStr.length === 'YYYY-MM-DDZ'.length) {
            const dt = moment(dateStr, 'YYYY-MM-DD')
            return dt.format('YYYY-MM-DD')
        }
        return moment(dateStr).format('YYYY-MM-DD');
    },
};


